import { BottomSheet } from './BottomSheet';
import { Button } from './Button';

/**
 * Один короткий вопрос перед необратимым действием.
 *
 * Появился, когда крестик на напоминании о незавершённой заявке стал по-настоящему удалять
 * черновик: до этого он прятал карточку до следующего захода, и «убрать» ничего не значило.
 * Удаление насовсем — честнее, но спрашивать перед ним обязательно: восстановить введённый адрес
 * и комментарий человеку будет неоткуда.
 *
 * Крой — `CarDeleteSheets`, потому что это тот же разговор: заголовок вопросом, одна строка про
 * последствие, действие в основной кнопке и «Отмена» призраком под ней. Отдельным компонентом,
 * а не третьим листом внутри той пары: там речь про технику и её мутацию, здесь — про что угодно
 * без сети.
 */
export function ConfirmSheet({
  open,
  title,
  subtitle,
  confirmLabel,
  cancelLabel = 'Отмена',
  onConfirm,
  onClose,
}: {
  open: boolean;
  title: string;
  /** Одна фраза про то, что случится. Без неё вопрос отвечают наугад. */
  subtitle: string;
  confirmLabel: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onClose: () => void;
}) {
  return (
    <BottomSheet open={open} onClose={onClose} title={title} subtitle={subtitle}>
      <div className="flex flex-col gap-2">
        <Button onClick={onConfirm}>{confirmLabel}</Button>
        <Button variant="ghost" onClick={onClose}>
          {cancelLabel}
        </Button>
      </div>
    </BottomSheet>
  );
}
